<template>
	<Loading :loading="loading">
		<div v-if="upgradeInfo">
		<!-- <div v-if="upgradeInfo" class="alert alert-success"> -->
		<div class="alert alert-success" v-if="canTransact && upgradeInfo && upgradeInfo.discount_amount && upgradeInfo.discount_amount > 0">
			Special offer!<br>
			Get {{CurrencyFormatter(upgradeInfo.discount_amount)}} off a membership upgrade.<br>
			{{upgradeInfo.discount_message}}

			<!-- Valid for the next X days. -->
			<!-- TODO wording -->
			<!-- <span v-if="upgradeInfo.discount_hours_remaining">{{upgradeInfo.discount_hours_remaining}} hours only!</span> -->
			<!-- <span v-if="upgradeInfo.discount_days_remaining">{{upgradeInfo.discount_days_remaining}} days!</span> -->
		</div>
		<div class="row">
			<div class="col-12 col-md-6">
			<span v-if="canTransact">
				<!-- <h2>Gold Upgrade</h2> -->
				<!-- <h2>Upgrade to Gold today & Save $500</h2>
				<p>Upgrade to Gold today, for just {{CurrencyFormatter(upgradeInfo.price)}}!</p> -->
				<h2>Limited Time Offer - Save $255 off the one-off joining fee</h2>
				<p style="font-size:16pt;">Become a <strong>Gold Member today for just {{CurrencyFormatter(upgradeInfo.price)}}</strong> and start enjoying savings of up to 60% off RRP straight away!</p>
				<p>Upgrade now to take advantage of this limited time offer.</p>
			
			</span>
			<span v-else>
				<h2>Welcome to Cherrytree Gold!</h2>
				<p>Pay your one-off joining fee of {{CurrencyFormatter(upgradeInfo.price)}} now and gain access to Gold Membership prices.</p>
			</span>
			<!-- <p v-if="!canTransact"><strong>You must pay the Gold Membership fee before you can start shopping at Gold prices</strong></p> -->
			<ButtonWithLoading
				text="Upgrade Now"
				state="null"
				class="centerButton"
				@click.native="upgradeToGold"
			/>
			<!-- <p class="mt-3">View our payment options <router-link :to="{ name: 'payment-options'}">Here</router-link>.</p> -->

			<div
				id="contactBox"
				class="col-11 mx-auto my-5 text-center"
			>
				<h2>Got a Question?</h2>
				Then Give Us a Call!
				<a href="tel:0800 243 779" class="boxLink">0800 243 779</a>
				<p>Or, pop in and see us.<br>1 Glover Court,<br>4 Glover Street, Ngauranga,<br>Wellington.</p>
				<span class="smallText">
				<p><i>Opening Hours</i></p>
				<p>Tuesday - Thursday: 9am - 5:30pm</p>
				<p>Friday: 9am - 5pm</p>
				<p>Saturday: 10am - 4pm</p>
				<p>Sunday: 1pm - 4pm</p>
				</span>
			</div>
			</div>
			
			<div 
			class="col-12 col-md-6"
			>
			<h2>Payment Plans Available</h2>
			<p>
				Here are the options:
			</p>
			<span v-if="canTransact">
			
				<ol>
				<li>Pay &#36;255 over 4 months with a &#36;25 administration charge</li>
				<li>Pay &#36;20.50 weekly (or fortnightly or monthly) over 12 months. A &#36;1.37 per week finance charge applies &amp; is paid over the period.</li>
				<li>Pay &#36;13.50 weekly (or fortnightly or monthly) over 24 months. A &#36;1.53 per week finance charge applies &amp; is paid over the period.</li>
				</ol>
				<p>
				Click here to see details and to complete the upgrade application.
				</p>
			</span>

			<span v-if="!canTransact">
				<ol>
				<li>Pay over four months with a &#36;30 administration charge.</li>
				<li>Flexible payment options are available (weekly, fortnightly or monthly) over a 12 or 24 month period. A &#36;2 weekly finance charge applies, which is charged upfront with your one-off joining fee.</li>
				</ol>
				<p>
				Click on the button below to choose the plan that best suits you.
				</p>
			
			</span>
			<!-- <p>
				Here are the options:
			</p>
				<ol>
				<li>Pay over four months with a &#36;30 administration charge.</li>
				<li>Flexible payment options are available (weekly, fortnightly or monthly) over a 12 or 24 month period. A &#36;2 weekly finance charge applies, which is charged upfront with your one-off joining fee.</li>
				</ol>
			<p v-if="canTransact">
				Click on the button to send us an email and we will send you the options and a link to set up your payments.<br>
				Remember, the more points you have earned, the lower the payments.
			</p>
			<p v-if="!canTransact">
				Click on the button below to choose the plan that best suits you.
			</p> -->


			<!-- <ButtonWithLoading
				text="Request Payment Plan Details"
				:state="paymentState"
				@click.native="sendPaymentPlanRequest"
				loadingText="Sending Email"
				class="centerButton"
				successText="Email Sent"
				failureText="Error Sending Email"
				v-if="canTransact"
			/>
			Button for members who signed up as silver and upgrade to gold.
			-->
			<a 
				class="btn btn-primary centerButton"
				target="_blank"
				v-if="canTransact"
				href="https://oc.debitsuccess.com/DirectEntry/DirectDebitRequest/Form?brandtemplateid=1e892af9-e59d-4aff-8aa6-3cc1a500932b#collapse[object%20Object]"
			>
				<!--href="https://oc.debitsuccess.com/DirectEntry/DirectDebitRequest/Form?brandtemplateid=c89886fe-dd69-43e9-a27e-4c934bcb72f1#collapse[object%20Object]"-->
				Payment Plan Details
			</a>
			<!-- Button for members who signed up as gold -->
			<a 
				class="btn btn-primary centerButton"
				target="_blank"
				v-if="!canTransact"
				href="https://oc.debitsuccess.com/DirectEntry/DirectDebitRequest/Form?brandtemplateid=84f7d003-2ae4-4ee1-b305-2598e285d414"
			>
				Payment Plan Details
			</a>

			<br>
			<h4
				v-if="canTransact"
				style="text-align:center;"  
			>
				Limited Time Offer!
			</h4>
			<!-- <p> We will send you an email shortly. Your account will be credited for the points you earned from purchases made as a Silver Member.</p> -->
			</div>

		</div>
		</div>
	</Loading>
</template>

<script>
import {fetchUpgradeInfo, postPaymentPlanRequest, fetchUserDetails} from '@/network/userRequests';
import {postPurchaseGoldMembership} from '@/network/cartRequests';
import {CurrencyFormatter} from "@/utils";
import { mapState } from "vuex";

import ButtonWithLoading from '@/components/buttonWithLoading';
import Loading from "@/components/loading/Loading";

export default {
	name: 'myAccountGoldUpgrade',
	components: {
		ButtonWithLoading,
		Loading
	},
	data(){
		return{
			loading: true,
			upgradeInfo: null,
			paymentState: null,
			user: null
		}
	},
	created(){
		this.getData();
	},
	methods:{
		CurrencyFormatter,

		getData(){
			this.loading = true;
			fetchUpgradeInfo()
				.then(response =>{
					this.upgradeInfo = response;
					this.loading = false;
				})
				.catch(() =>{
					// console.log("error getting upgrade price")
					this.loading = false;
				})
			fetchUserDetails(userDetails => {
				this.user = userDetails;
			});
		},
		upgradeToGold(){
			this.$gtm.trackEvent({
				event: 'goldUpgrade',
				value: this.user.member_details.account_id_fk,
			});
			postPurchaseGoldMembership().then(result =>{
				if(result.success){
					this.$router.push({name: 'payment', params:{paymentUrl: result.url, type: 'goldUpgrade'}})
				}
			});
		},
		sendPaymentPlanRequest(){
			this.paymentState = 'loading'
			let email = this.user.member_details.email
			let id = this.user.member_details.account_id_fk
			let name = this.user.member_details.given_name + " " + this.user.member_details.family_name
			postPaymentPlanRequest({member_name: name, member_email: email, member_id: id}, 
				()=>{
					this.paymentState="success"
				}, ()=>{
					this.paymentState="failure"
				})
			setTimeout(() => {
				this.paymentState = null;
			}, 4500);
		}
	},
	computed:{
		...mapState({
			canTransact: state => state.member.canTransact,
			memberLevel: state => state.auth.memberLevel,
		})
	}
}
</script>

<style lang="scss">

#contactBox {
	border: solid #000 2px;
	// height: 350px;
	font-size: 16pt;
	box-sizing: border-box;
	padding: 5px;
	.boxLink {
		color: $CTred;
		font-size: 28pt;
		font-weight: 600;
		display: block;
		&:visited { 
		color: $CTred
		}
	}
	.smallText {
		font-size: 12pt;
	}
}

.centerButton {
	margin-left: auto;
	margin-right: auto;
	display: block;
	width: fit-content;

}

@include media-breakpoint-down(md) {
	.boxLink {
		font-size: 22pt !important;
	}
}

</style>
